module.exports = "/images/vendor/flag-icon-css/flags/1x1/hn.svg?c94622ad395a0173231ae8ac41bf45a4";